import { useUserInfoStore } from "@/shared/store/user-info-store";

import type { ServiceHandler } from "../bridge/message-router";

/**
 * 用户服务：向插件暴露当前登录用户的只读信息字段，数据来源于 shared 层的 user-info-store。
 */
export const userServiceHandler: ServiceHandler = async (_pluginId, method) => {
  switch (method) {
    case "getProfile": {
      const userInfo = useUserInfoStore.getState().userInfo;
      if (!userInfo) {
        return { id: "", name: "", avatar: "", email: "" };
      }
      return {
        id: userInfo.id,
        name: userInfo.nickname,
        avatar: userInfo.qq?.avatar_url ?? userInfo.wechat?.avatar_url ?? "",
        email: userInfo.email,
      };
    }

    default:
      throw Object.assign(new Error(`Unknown user method: ${method}`), { code: "UNKNOWN_METHOD" });
  }
};
